import React, { useEffect } from "react";
import styled from "styled-components";
import {
  PointTabBar,
  PointTabColumn,
  PointTabContainer,
  PointTabText,
} from "../../Benefit/Point/PointTab";
import { atom, useRecoilState } from "recoil";

export const uplusTabState = atom<number>({
  key: "uplusTabState",
  default: 0,
});

export default function UplusTab() {
  const [tab, setTab] = useRecoilState(uplusTabState);

  useEffect(() => {
    setTab(0);
  }, []);

  return (
    <PointTabContainer>
      <PointTabColumn onClick={() => setTab(0)}>
        <PointTabText isActive={Boolean(tab === 0)}>결합 내역</PointTabText>

        <UplusTabBar tab={tab} />
      </PointTabColumn>

      <PointTabColumn onClick={() => setTab(1)}>
        <PointTabText isActive={Boolean(tab === 1)}>
          데이터 업로드 이력
        </PointTabText>
      </PointTabColumn>
    </PointTabContainer>
  );
}

const UplusTabBar = styled(PointTabBar)`
  width: ${({ tab }) => (tab === 0 ? 70 : 140)}px;
  left: ${({ tab }) => (tab === 0 ? 0 : 85)}px;
`;
